import {Routes} from '@angular/router';

export const memberManagementRoutes: Routes = [
  {
    path: 'memberManagement',
    loadComponent: () => import('./member-management.component').then(m => m.MemberManagementComponent),
    data: {title: '会员管理'},
    children: [
      {
        path: 'member.mgr',
        loadComponent: () => import('./member.mgr/member.mgr.component').then(m => m.MemberMgrComponent),
        data: {key:"01J7NE5E5HZZMVJ3TRGYNMTX1W", keep: true,title: "会员管理"},
      },
      {
        path: 'member.equity',
        loadComponent: () => import('./member.equity/member.equity.component').then(m => m.MemberEquityComponent),
        data: {key:"01J7Q7C1NEY65267FF5D326DE3", keep: true,title: "会员权益"},
      },
      {
        path: 'member.balance',
        loadComponent: () => import('./member.balance/member.balance.component').then(m => m.MemberBalanceComponent),
        data: {key:"01J8HXQ2GWXRT3B292S9E28NW1", keep: true,title: "余额入账"},
      },
      {
        path: 'balance.out',
        loadComponent: () => import('./balance.out/balance.out.component').then(m => m.BalanceOutComponent),
        data: {key:"01J8S6VFWGDFRYZTRZP0KQK89C", keep: true,title:"余额核销"},
      },
    ]
  },
];
